import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ListaService } from '../../_services/lista.service';
import { ListaItem } from '../../_models/lista-item';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { Plaga } from '../../_models/plaga';
import { ControlPlagaService } from '../../_services/control-plaga.service';
import { ControlPlaga } from '../../_models/control-plaga';

@Component( {
  selector: 'app-plaga-producto-comercial',
  templateUrl: 'plaga-producto-comercial.component.html'
} )

export class PlagaProductoComercialComponent implements OnInit {
  formulario: FormGroup;
  @Input() plaga: Plaga;
  plagaProductoComercial: ControlPlaga;

  /** Listas */
  lisPlagaProductoComercial: ControlPlaga[] = [];
  lisControlesPlagasTodos: ListaItem[] = [];
  lisControlesPlagas: SelectItem[] = [];

  columnas: any[] = [];
  carInformacionInicial = true;
  tabSeleccionado = 'VARIABLE';
  submitted = false;
  guardando = false;
  carTabla = true;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();


  constructor(
    private conServicio: ConfirmationService,
    private fb: FormBuilder,
    private serControlPlaga: ControlPlagaService,
    private route: ActivatedRoute,
    private lisServicio: ListaService,
    private navServicio: NavService,
    private router: Router,
    private autServicio: AutenticacionService,
    private serLista: ListaService
  ) {
  }

  ngOnInit() {

    if ( this.plaga && (this.plaga.idPlaga !== '' && this.plaga.idPlaga !== null && this.plaga.idPlaga !== undefined) ) {
      /** Se carga la plaga producto comercial */
      this.serControlPlaga.listadoPorPlaga( this.plaga.idPlaga ).subscribe( registros => {
        this.lisPlagaProductoComercial = registros;
        this.cargarInformacionInicial();
      } );
    }

  }

  cargarInformacionInicial() {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/plaga' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PLAGA.LBL_PRODCOMER' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.formulario = this.fb.group( {
      idPlaga: [ this.plaga ? this.plaga.idPlaga : null, [ Validators.required ] ],
      idControlPlaga: [ this.plagaProductoComercial ? this.plagaProductoComercial.idControlPlaga : null ],
      idTipoControlPlaga: [ this.plagaProductoComercial ? this.plagaProductoComercial.idTipoControlPlaga : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.plagaProductoComercial ? this.plagaProductoComercial.indicadorHabilitado : true, [ Validators.required ] ]
    } );
    this.serLista.getMasterDetails( 'ListasTiposControlesPlagas' ).subscribe( controles => {
      this.lisControlesPlagasTodos = controles;
      this.lisControlesPlagasTodos.map( ( s: ListaItem ) => {
        if ( !this.lisPlagaProductoComercial.find( x => x.idTipoControlPlaga === s.idLista ) )
          this.lisControlesPlagas.push( { label: s.nombre, value: s.idLista } );
      } );
      this.carTabla = false;
      this.carInformacionInicial = false;
    } );

  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      const formulario = this.formulario.getRawValue();
      /** Actualizar plaga control */
      if ( formulario.idControlPlaga ) {
        this.serControlPlaga.actualizar( formulario ).subscribe( regActualizado => {
          this.lisPlagaProductoComercial = [];
          this.serControlPlaga.listadoPorPlaga( this.plaga.idPlaga ).subscribe( registros => {
            this.lisPlagaProductoComercial = registros;
            this.guardando = false;
            this.submitted = false;
            this.carTabla = false;
            this.plagaProductoComercial = null;
            this.formulario.reset();
            this.f.idPlaga.setValue( this.plaga.idPlaga );
            this.f.indicadorHabilitado.setValue( true );
            this.verificarLista();
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGACTU' )
            } );
          } );
        } );

      } else {
        /** Crear plaga control */
        this.serControlPlaga.crear( formulario ).subscribe( reg => {
          this.lisPlagaProductoComercial = [];
          this.serControlPlaga.listadoPorPlaga( this.plaga.idPlaga ).subscribe( regActualizado => {
            this.lisPlagaProductoComercial = regActualizado;
            this.guardando = false;
            this.submitted = false;
            this.carTabla = false;
            this.plagaProductoComercial = null;
            this.formulario.reset();
            this.f.idPlaga.setValue( this.plaga.idPlaga );
            this.f.indicadorHabilitado.setValue( true );
            this.verificarLista();
            this.navServicio.setMesage( 0, {
              severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.navServicio.buscarMensaje( 'ESTRUCTURAAGRICOLA.LBL_REGGUAR' )
            } );
          } );
        } );
      }


    }
  }

  editar( reg: ControlPlaga ) {
    let prodAgri = this.lisControlesPlagasTodos.find( x => x.idLista === reg.idTipoControlPlaga );
    this.lisControlesPlagas.push( { label: prodAgri.nombre, value: prodAgri.idLista } );
    this.plagaProductoComercial = reg;
    this.formulario.reset();
    this.f.idPlaga.setValue( this.plaga.idPlaga );
    this.f.idControlPlaga.setValue( this.plagaProductoComercial.idControlPlaga );
    this.f.idTipoControlPlaga.setValue( this.plagaProductoComercial.idTipoControlPlaga );
    this.f.indicadorHabilitado.setValue( this.plagaProductoComercial.indicadorHabilitado );
  }

  verificarLista() {
    this.lisControlesPlagas = [];
    this.lisControlesPlagasTodos.map( ( s: ListaItem ) => {
      if ( !this.lisPlagaProductoComercial.find( x => x.idTipoControlPlaga === s.idLista ) )
        this.lisControlesPlagas.push( { label: s.nombre, value: s.idLista } );
    } );
  }

}
